import { render, staticRenderFns } from "./interface-debugger.vue?vue&type=template&id=35621331&scoped=true&"
import script from "./interface-debugger.vue?vue&type=script&lang=js&"
export * from "./interface-debugger.vue?vue&type=script&lang=js&"
import style0 from "./interface-debugger.vue?vue&type=style&index=0&id=35621331&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35621331",
  null
  
)

export default component.exports